import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=f86cf996&"
import script from "./CheckboxComponent.vue?vue&type=script&lang=ts&"
export * from "./CheckboxComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports